// extracted by mini-css-extract-plugin
export var orange = "revs-module--orange--d1f3b";
export var purple = "revs-module--purple--29b91";
export var revs = "revs-module--revs--64559";
export var yellow = "revs-module--yellow--6a148";